<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ liên lạc" :link="[{ text: 'Sổ liên lạc', href: '/head-contact-book' }]" />
    </div>

    <v-card class="ma-4">
      <v-row class="pl-4">
        <v-col cols="12" md="2" class="">
          <div>Lớp</div>
          <h3>{{ className }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Ngày</div>
          <h3>{{ date | ddmmyyyy }}</h3>
        </v-col>
        <v-col cols="12" md="2" class="">
          <div>Sĩ số</div>
          <h3>{{ studentClassCount }}</h3>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="ma-4 mt-6 pa-4">
      <div class="d-flex justify-center flex-column align-center" v-if="fetchButtonLoading">
        <v-progress-circular indeterminate color="primary" class="mb-4" />
        <div class="primary--text">Đang tổng kết dữ liệu...</div>
      </div>
      <div v-if="!isSaveable">
        <div>Hiện chưa có dữ liệu về điểm số, khen thưởng kỷ luật hoặc nhắc nhở của học sinh.</div>
        <v-btn class="mt-2" outlined light depressed @click="onFetchData" :loading="fetchButtonLoading"
          >Tổng kết lại</v-btn
        >
      </div>
      <div class="v-data-table__wrapper" v-show="configs.length > 0 && isSaveable">
        <table :key="tableKey" class="config-table">
          <thead class="v-data-table-header">
            <tr>
              <th class="text-left pa-2" style="width: 250px;">Học sinh</th>
              <th class="text-left pa-2">Nội dung ghi nhận</th>
              <th class="text-left pa-2" style="width: 150px;">Xử lý</th>
              <th class="text-left pa-2">Nội dung tin gửi đi</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in configs" :key="index">
            <tr>
              <td :rowspan="item.contents.length + 1" class="text-left pa-2">
                <router-link style="text-decoration: none" :to="`/student/${item.studentId}`">
                  <CardStudentName :student="item.student" link />
                </router-link>
              </td>
            </tr>
            <tr v-for="(cItem, cIdx) in item.contents" :key="cIdx">
              <td class="text-left pa-2">
                <div>
                  <div class="mb-2">
                    <v-chip small label :color="getColor(cItem)" dark>
                      <span v-if="cItem">
                      {{ cItem | getContentPrefix }}
                      </span>
                    </v-chip>
                  </div>
                  {{ cItem | getContent }}
                </div>
              </td>
              <td class="pa-2">
                <v-switch
                  v-model="cItem.config"
                  :label="cItem.config ? 'Gửi' : 'Không gửi'"
                  hide-details
                  :disabled="!isEditable"
                  v-show="isEditable"
                  @change="onSwitchChange(item.studentId, cItem)"
                />

                <div v-show="!isEditable">
                  {{ cItem.config ? 'Gửi' : 'Bỏ qua' }}
                </div>
              </td>
              <td class="text-left pa-2">
                <div v-if="cItem.config">
                  <div class="mb-2">
                    <v-chip small label :color="getColor(cItem)" dark>
                      <span v-if="cItem">
                        {{ cItem | getContentPrefix }}
                      </span>
                    </v-chip>
                  </div>
                  <v-textarea
                    v-model="cItem.messageContent"
                    auto-grow
                    outlined
                    dense
                    hide-details
                    :disabled="!isEditable"
                    placeholder="Nhập nội dung gửi đi"
                    @input="onMessageContentChange(item.studentId, cItem)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-end" :class="{ 'mt-2': configs.length > 0 }" v-if="isEditable">
        <!-- <v-btn class="ma-2" outlined light depressed @click="onFetchData" :loading="fetchButtonLoading">Tổng kết</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          dark
          depressed
          color="#0D47A1"
          @click="onSaveData"
          v-show="configs.length > 0 && isSaveable"
          :loading="saveButtonLoading"
          >Xác nhận & Gửi đi</v-btn
        >
      </div>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import CardStudentName from '@/views/student/components/CardStudentName.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'
export default {
  components: {
    Breadcrumbs,
    CardStudentName
  },
  filters: {
    getContentPrefix: (item = {}) => {
      switch (item.type) {
        case 'mark':
          return 'Điểm số'
        case 'violation_commendation':
          return 'Khen thưởng'
        case 'violation_violation':
          return 'Vi phạm'
        case 'reminder':
          return `Nhắc nhở của GVBM ${get(item, 'subject.title', '')}`
        default:
          return ''
      }
    },
    getContent: (item = {}) => {
      let content = ''
      content += item.content
      if (get(item, 'subject.title', '')) {
        content += ' trong tiết ' + item.subject.title + '.'
      }
      return content
    }
  },
  data() {
    return {
      configs: [],
      tableKey: Date.now(),
      className: '',
      studentClassCount: '',
      fetchButtonLoading: false,
      saveButtonLoading: false,
      isEditable: false,
      isSaveable: true
    }
  },
  computed: {
    ...mapGetters('app', ['department', 'role', 'commonQuery']),
    ...mapState('app', ['currentGeneration', 'currentSemester']),
    ...mapGetters('auth', ['profile']),
    ...mapGetters('HeadContactBookDetail', ['getIsConfigsExisted']),
    date() {
      return moment(this.$route.params.date)
    }
  },
  async created() {
    const classId = this.$route.params.id
    const date = this.$route.params.date
    const res = await this.fetchOneClass(classId)
    await this.setEditable()
    this.className = get(res, 'title', '')
    this.studentClassCount = get(res, 'students.length', '')
    // if (isEditable) {
    await this.onFetchData({ classId, date })
    // }
  },
  methods: {
    ...mapActions('HeadContactBookDetail', ['fetchData', 'createData', 'fetchOneClass', 'fetchConfigByDate']),
    getColor(s) {
      switch (s.type) {
        case 'mark':
          return 'Điểm số'
        case 'violation_commendation':
          return '#46BE8A'
        case 'violation_violation':
          return 'orange'
        case 'reminder':
          return `yellow`
        default:
          return ''
      }
    },
    async onFetchData() {
      this.fetchButtonLoading = true
      const classId = this.$route.params.id
      const date = this.$route.params.date
      const res = await this.fetchData({ classId, date })
      this.configs = res.map(item => ({
        ...item,
        contents: item.contents.map(cItem => ({
          ...cItem,
          messageContent: cItem.messageContent || `${this.$options.filters.getContent(cItem)}`
        }))
      }))

      this.loadFromLocalStorage()
      if (!res.filter(x => x.contents.length > 0).length) {
        this.isSaveable = false
      }
      this.tableKey = Date.now()
      this.fetchButtonLoading = false
    },
    onSaveData() {
      this.$dialog.confirm({
        title: 'Xác nhận lưu thiết lập và gửi tin',
        text: 'Thiết lập sau khi đã gửi sẽ không thể hoàn tác',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.saveButtonLoading = true

            const classId = this.$route.params.id
            const date = this.$route.params.date

            const configHistory = {}
            this.configs.forEach(item => {
              item.contents.forEach(cItem => {
                const key = `${item.studentId}_${cItem.id}`
                configHistory[key] = {
                  ...cItem,
                  config: cItem.config,
                  type: cItem.type,
                  content: cItem.messageContent || cItem.content,
                  studentName: item.studentName
                }
              })
            })
            await this.createData({
              configHistory,
              date,
              status: 'sent',
              classId,
              staffId: this.profile.id,
              // generationId: this.currentGeneration.id
            })

            await this.setEditable()

            this.$alert.updateSuccess()
            this.clearLocalStorage()
            this.saveButtonLoading = false
          } catch (error) {
            console.error(error)
            this.saveButtonLoading = false
            this.saveToLocalStorage()
            this.$alert.updateError()
          }
        }
      })
    },
    async setEditable() {
      const classId = this.$route.params.id
      const date = this.$route.params.date
      const configs = await this.fetchConfigByDate({ class: classId, date })
      this.isEditable = !configs.length
      return !configs.length
    },
    onSwitchChange(studentId, contentItem) {
      // if (!contentItem.config) {
      //   contentItem.messageContent = ''
      // }
      this.saveToLocalStorage()
    },
    onMessageContentChange(studentId, contentItem) {
      this.saveToLocalStorage()
    },

    getLocalStorageKey() {
      const classId = this.$route.params.id
      const date = this.$route.params.date
      return `head-contact-book_${classId}_${date}`
    },
    saveToLocalStorage() {
      const key = this.getLocalStorageKey()
      const localData = this.configs.map(item => ({
        studentId: item.studentId,
        contents: item.contents.map(cItem => ({
          id: cItem.id,
          messageContent: cItem.messageContent || '',
          config: !!cItem.config,
        }))
      }))
      localStorage.setItem(key, JSON.stringify(localData))
    },
    loadFromLocalStorage() {
      const key = this.getLocalStorageKey()
      const saved = localStorage.getItem(key)
      if (!saved) return
      const parsed = JSON.parse(saved)
      this.configs.forEach(item => {
        const savedItem = parsed.find(p => p.studentId === item.studentId)
        if (savedItem) {
          item.contents.forEach(cItem => {
            const savedContent = savedItem.contents.find(c => c.id === cItem.id)
            if (savedContent) {
              cItem.messageContent = savedContent.messageContent
              cItem.config = savedContent.config
            }
          })
        }
      })
    },
    clearLocalStorage() {
      localStorage.removeItem(this.getLocalStorageKey())
    }
  }
}
</script>
<style lang="scss" scoped>
.config-table {
  table-layout: fixed;
  width: 100%;
  border: 1px solid #f2f0f1;
  border-collapse: collapse;
  thead {
    th {
      background-color: #f2f0f1;
      border: 1px solid #e0e0e0;
    }
  }
  tbody {
    td {
      background-color: #ffffff;
      border: 1px solid #e0e0e0;
      vertical-align: top;
      ::v-deep {
        .v-input--selection-controls {
          margin: 0;
        }
      }
    }
  }
}
</style>